import React from 'react'
import ReactDOM from 'react-dom/client'
import Application from './Application.jsx'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import { checkVersion } from './Project/Services/utils.js'

// Проверяем версию при загрузке приложения
checkVersion(); 

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <BrowserRouter>
      <Application></Application>
      {/* <App></App> */}
    </BrowserRouter>
  // </React.StrictMode>
) 